var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EAECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.761 20.001C27.761 20.8145 28.429 21.4764 29.25 21.4764C29.664 21.4764 30 21.8093 30 22.2195V24.8958C30 27.159 28.142 29 25.858 29H14.143C11.859 29 10 27.159 10 24.8958V22.2195C10 21.8093 10.336 21.4764 10.75 21.4764C11.572 21.4764 12.24 20.8145 12.24 20.001C12.24 19.2083 11.599 18.6118 10.75 18.6118C10.551 18.6118 10.361 18.5335 10.22 18.3938C10.079 18.2541 10 18.0648 10 17.8687L10.002 15.1051C10.002 12.842 11.86 11 14.144 11H25.856C28.14 11 29.999 12.842 29.999 15.1051L30 17.7825C30 17.9786 29.921 18.1689 29.781 18.3076C29.64 18.4473 29.45 18.5256 29.25 18.5256C28.429 18.5256 27.761 19.1875 27.761 20.001ZM22.252 20.648L23.431 19.5105C23.636 19.3143 23.707 19.025 23.618 18.7575C23.53 18.4899 23.3 18.2997 23.022 18.261L21.393 18.0252L20.664 16.5627C20.539 16.311 20.285 16.1545 20.002 16.1535H20C19.718 16.1535 19.464 16.31 19.337 16.5617L18.608 18.0252L16.982 18.26C16.701 18.2997 16.471 18.4899 16.382 18.7575C16.294 19.025 16.365 19.3143 16.569 19.5105L17.748 20.648L17.47 22.2562C17.422 22.5336 17.535 22.8091 17.765 22.9746C17.895 23.0667 18.046 23.1143 18.199 23.1143C18.316 23.1143 18.434 23.0855 18.542 23.0291L20 22.2701L21.455 23.0271C21.707 23.1608 22.006 23.14 22.235 22.9736C22.466 22.8091 22.579 22.5336 22.531 22.2562L22.252 20.648Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketCircle);
export default __webpack_public_path__ + "static/media/ticket-circle.766374700cc1290a96fadb85cb646ad1.svg";
export { ForwardRef as ReactComponent };